import React from "react";
import { sepJustMoney } from "../../../Function";

const Payment = ({ payment, title = "undefind" }) => {
  const HandlerData = KEY => {
    switch (KEY) {
      case "type_payment":
        return {
          name: "نوع پرداخت",
          value: RendertypePay(payment[KEY]),
        };
      // case "ref_id":
      //   return {
      //     name: "شماره ارجاع",
      //     value: payment[KEY] != null ? payment[KEY] : "ثبت نشده است",
      //   };
      case "transid":
        return {
          name: "شماره تراکنش",
          value: payment[KEY] ? payment[KEY] : "ثبت نشده است",
        };
      case "trackingcode":
        return {
          name: "شماره پیگری پرداخت",
          value: payment[KEY],
        };
      case "total_price":
        return {
          name: "مبلغ",
          value: sepJustMoney(payment[KEY]) + " تومان",
        };
      case "status":
        return {
          name: "وضعیت",
          value: Renderststus(payment[KEY]),
        };
      case "bankmessage":
        if (payment && payment.status && payment.status == "error")
          return {
            name: "خطای بانک",
            value: payment[KEY],
          };
        break;
    }
  };
  const RendertypePay = type => {
    switch (type) {
      case "gateway":
        return "پرداخت آنلاین";
      case "wallet":
        return "پرداخت از کیف پول";
      case "others":
        return "پرداخت در محل";
    }
  };
  const Renderststus = type => {
    switch (type) {
      case "peyed":
        return "پرداخت شده";
      case "error":
        return "عدم پرداخت";
      case "waittopay":
        return "پرداخت رها شده";
    }
  };
  return (
    <div style={{ marginBottom: "30px" }}>
      <div style={{ borderBottom: "1px solid red" }} className="mb-2">
        {title === "undefind" ? (
          <h4 style={{ fontSize: "18px" }}>مشخصات پرداخت</h4>
        ) : (
          <h4 style={{ fontSize: "18px" }}>مشخصات آخرین پرداخت</h4>
        )}
      </div>
      <div className="row justify-content-between px-2">
        {Object.keys(payment).map(function (value, key) {
          if (HandlerData(value))
            return (
              <div
                key={key}
                className={`col-md-6 d-flex ${window.innerWidth > 600
                    ? "justify-content-start"
                    : "justify-content-between"
                  }   align-items-center `}
              >
                <div>
                  <span style={{ fontWeight: "500", fontSize: "14px" }}>
                    {HandlerData(value)["name"]} :
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: "400", fontSize: "14px", marginRight: "5px" }}>
                    {HandlerData(value)["value"]}
                  </span>
                </div>
              </div>
            );
        })}
      </div>
    </div>
  );
};

export default Payment;
